import { useContext, useState } from "react"
import { conffetiContext, OrdersContext, PopUpContext, UserContext } from "../layout/Root"

export default function OrderDish({ d = {} }) {
   const [amount, setAmount] = useState(1)
   const [notes, setNotes] = useState('')
   const [TotalOrders, setTotalOrders] = useContext(OrdersContext)
   const [, setPopUp] = useContext(PopUpContext)
   const [, setConffeti] = useContext(conffetiContext)
   const [user] = useContext(UserContext)

   function AddToCart() {
      const exictOrderToUser = TotalOrders.find(o => o.user._id === user._id)
      const newOrder = { ...d, amount, notes, status: 'In Progress', _id: Math.random() }
      if (!exictOrderToUser)
         setTotalOrders(old => [...old, { user, orders: [newOrder], info: { paid: false, _id: Math.random() } }])
      else
         setTotalOrders(old => old.map(or => or.user._id !== user._id ? or : { ...or, orders: [...or.orders, newOrder] }))
      setPopUp()
      setConffeti(true)
   }

   return (
      <div>
         <img src={d.img} width={'100%'} alt={d.title} />
         <h3 className="mt-2 fw-bold">- {d.title} -</h3>
         <p className="mb-1">{d.desc}</p>
         <p className="me-2 mb-1"> {d.calories} calories</p>
         <p className="mb-1 fw-bold">Notes:</p>
         <textarea className="form-control mb-3" onChange={e => setNotes(e.target.value)} cols="30" rows="4" />
         <p className="badge bg-secondary rounded-pill p-2 px-5 fs-6 mb-3 fw-light"> ${d.price} Per Dish</p>
         <div className="d-flex justify-content-between align-items-center">
            <div>
               Amount:  <input className="mx-1 px-1 form-control" type='number' min={1} onChange={e => setAmount(Number(e.target.value))} value={amount} style={{ width: '40px', display: 'inline' }} />
            </div>
            <button onClick={AddToCart} className="btn btn-primary">Total Price : ${d.price * amount}
            </button>
         </div>
      </div>
   )
} 
